import React, { useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

// i18n
import i18n from "../../../i18n";
import { useTranslation } from "react-i18next";

// Flags
import india from "../../../assets/images/flags/india.png";
import spain from "../../../assets/images/flags/spain.jpg";
import germany from "../../../assets/images/flags/germany.jpg";
import italy from "../../../assets/images/flags/italy.jpg";
import russia from "../../../assets/images/flags/russia.jpg";

const LanguageDropdown = () => {
  const { t } = useTranslation();
  const [menu, setMenu] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState({
    lng: "English",
    flag: india,
  });

  const toggle = () => setMenu(!menu);

  const changeLanguageAction = (lng) => {
    // Set the selected language to i18n
    i18n.changeLanguage(lng);

    // Update state based on selected language
    switch (lng) {
      case "sp":
        setSelectedLanguage({ lng: "Spanish", flag: spain });
        break;
      case "gr":
        setSelectedLanguage({ lng: "German", flag: germany });
        break;
      case "rs":
        setSelectedLanguage({ lng: "Russian", flag: russia });
        break;
      case "it":
        setSelectedLanguage({ lng: "Italian", flag: italy });
        break;
      default:
        setSelectedLanguage({ lng: "English", flag: india });
        break;
    }
  };

  return (
    <Dropdown
      isOpen={menu}
      toggle={toggle}
      className="d-none d-sm-inline-block"
    >
      <DropdownToggle tag="button" className="btn header-item waves-effect">
        <img src={selectedLanguage.flag} alt="Header Language" height="16" />
      </DropdownToggle>

      {/* <DropdownMenu className="dropdown-menu-end">
        <DropdownItem
          active={selectedLanguage.lng === "English"}
          onClick={() => changeLanguageAction("eng")}
          className="notify-item"
        >
          <img src={india} alt="English" className="me-1" height="12" />{" "}
          <span className="align-middle">English</span>
        </DropdownItem>

        <DropdownItem
          active={selectedLanguage.lng === "Spanish"}
          onClick={() => changeLanguageAction("sp")}
          className="notify-item"
        >
          <img src={spain} alt="Spanish" className="me-1" height="12" />{" "}
          <span className="align-middle">Spanish</span>
        </DropdownItem>

        <DropdownItem
          active={selectedLanguage.lng === "German"}
          onClick={() => changeLanguageAction("gr")}
          className="notify-item"
        >
          <img src={germany} alt="German" className="me-1" height="12" />{" "}
          <span className="align-middle">German</span>
        </DropdownItem>

        <DropdownItem
          active={selectedLanguage.lng === "Italian"}
          onClick={() => changeLanguageAction("it")}
          className="notify-item"
        >
          <img src={italy} alt="Italian" className="me-1" height="12" />{" "}
          <span className="align-middle">Italian</span>
        </DropdownItem>

        <DropdownItem
          active={selectedLanguage.lng === "Russian"}
          onClick={() => changeLanguageAction("rs")}
          className="notify-item"
        >
          <img src={russia} alt="Russian" className="me-1" height="12" />{" "}
          <span className="align-middle">Russian</span>
        </DropdownItem>
      </DropdownMenu> */}
    </Dropdown>
  );
};

export default LanguageDropdown;
